<nz-form-control *ngIf="recordProperty !== undefined && editMode == false">
  <nz-input-group>
    <!-- {{recordProperty.ValueAsObject}} -->
    <span class="edit-span" (click)="changeEditMode(true);" [innerHTML]="recordProperty.ValueAsObject">
    </span>
  </nz-input-group>
</nz-form-control>

<nz-form-control *ngIf="recordProperty !== undefined && editMode == true">
  <nz-input-group [nzSuffix]="inputClearTpl">
    <input type="text"
    [class]="parentClass"
    [name]="sectionTagName+'.' +field.FieldName" nz-input [ngModelOptions]="{ updateOn: 'blur' }"
      [(ngModel)]="recordProperty.ValueAsObject" (ngModelChange)="valueChanged()" (focusout)="changeEditMode(false);" />
  </nz-input-group>
  <ng-template #inputClearTpl><i nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
      *ngIf="recordProperty.ValueAsObject" (click)="recordProperty.ValueAsObject = null;valueChanged()"></i>
  </ng-template>
</nz-form-control>
